module.exports = __webpack_public_path__ + "static/img/ISO45001.335d839.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/ISO45001.png
// module id = uLXb
// module chunks = 1